import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { darkGrayFontColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	card: {
		boxSizing: 'border-box',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		width: '100%',
		':has(*) *': {
			boxSizing: 'border-box',
		},
	},
	cardHeader: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
	},
	headerContent: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	statusDot: {
		backgroundColor: THEME.colors.success.main,
		borderRadius: '50%',
		flexShrink: 0,
		height: 8,
		width: 8,
	},
	rows: {
		borderTop: `1px solid ${THEME.colors.border.light}`,
		display: 'flex',
		flexDirection: 'column',
		paddingTop: THEME.spacing.xs,
	},
	agentRow: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: THEME.spacing.md,
		padding: `${THEME.spacing.sm}px 0`,
	},
	rowIcon: {
		alignItems: 'center',
		color: THEME.colors.primary.main,
		borderRadius: 12,
		display: 'flex',
		flexShrink: 0,
		justifyContent: 'center',
	},
	rowBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		flex: 1,
		// minWidth: 0 lets the nowrap detail line ellipsize instead of forcing the row wider than the card.
		minWidth: 0,
	},
	rowTitle: {
		color: THEME.colors.text.dark,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	rowTitleMeta: {
		color: darkGrayFontColor,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.standard,
		marginLeft: THEME.spacing.sm,
	},
	rowDetail: {
		color: darkGrayFontColor,
		fontSize: THEME.typography.fontSizes.sm,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	rowAction: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
		gap: THEME.spacing.md,
		marginLeft: 'auto',
	},
	scheduleLink: {
		color: THEME.colors.primary.main,
		fontSize: THEME.typography.fontSizes.sm,
		textDecoration: 'none',
		whiteSpace: 'nowrap',
		':hover': {
			textDecoration: 'underline',
		},
	},
	failureNote: {
		color: THEME.colors.danger.main,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
	skeletonIcon: {
		borderRadius: 12,
		flexShrink: 0,
		height: 40,
		width: 40,
	},
	skeletonTitle: {
		height: 16,
		maxWidth: 180,
		width: '40%',
	},
	skeletonDetail: {
		height: 14,
		maxWidth: 420,
		width: '70%',
	},
});
